import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { FASES } from "@/hooks/useImportJob";

export function ImportProgress({ job, testid = "import-progress" }) {
  if (!job) return null;
  const idx = Math.max(0, FASES.indexOf(job.fase));
  const done = job.status === "concluido";
  const err = job.status === "erro";
  const pct = done ? 100 : err ? 100 : Math.min(95, Math.round(((idx + (job.total ? job.atual / job.total : 0)) / FASES.length) * 100));
  return (
    <div className="mt-3 space-y-2" data-testid={testid}>
      <div className="flex items-center justify-between text-xs">
        <span className="flex items-center gap-1.5 font-semibold text-[#0F2A1F]" data-testid={`${testid}-fase`}>
          {done ? <CheckCircle2 className="w-3.5 h-3.5 text-[#047857]" /> : err ? <XCircle className="w-3.5 h-3.5 text-[#B91C1C]" /> : <Loader2 className="w-3.5 h-3.5 animate-spin text-[#2DC26B]" />}
          {job.fase}
          {job.fase === "Processando linhas" && job.total ? <span className="font-mono text-[#5A6B62]">({job.atual} de {job.total})</span> : null}
        </span>
        <span className="font-mono text-[#5A6B62]">{pct}%</span>
      </div>
      <div className="h-1.5 bg-[#F1F5F2] rounded-full overflow-hidden">
        <div className={`h-full transition-[width] duration-500 ${err ? "bg-[#B91C1C]" : done ? "bg-[#047857]" : "bg-[#2DC26B]"}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="flex justify-between text-[10px] text-[#8A9A90]">
        {FASES.map((f, i) => <span key={f} className={i <= idx ? "text-[#0F2A1F] font-semibold" : ""}>{f.split(" ")[0]}</span>)}
      </div>
    </div>
  );
}

export function ResumoImportacao({ r, testid = "import-resumo" }) {
  if (!r) return null;
  const items = [["Incluídos", r.incluidos, "#047857"], ["Alterados", r.alterados, "#0F6B3A"], ["Removidos", r.removidos, "#B91C1C"],
    ["Vazios", r.vazios, "#B8860B"], ["Duplicados", r.duplicados, "#8A9A90"]];
  return (
    <div className="mt-3 grid grid-cols-5 gap-1.5" data-testid={testid}>
      {items.map(([l, v, c]) => (
        <div key={l} className="bg-[#F4F8F5] border border-[#F1F5F2] rounded-md px-2 py-1.5 text-center">
          <div className="text-[10px] uppercase tracking-wide text-[#8A9A90]">{l}</div>
          <div className="font-mono font-bold text-sm" style={{ color: c }}>{v ?? 0}</div>
        </div>
      ))}
    </div>
  );
}
